import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { useLocalizeMessage, Table, SegmentedControl } from 'libs.nucleus';
import { useParticipantsTableColumns } from './participants_table_columns.hook';
import { EParticipantCategory, useFetchParticipants } from '../../hooks/use_fetch_participants';
const DEFAULT_PAGE_SIZE = 10;
export const ParticipantsTable = () => {
    const translate = useLocalizeMessage();
    const { participantsColumns } = useParticipantsTableColumns();
    const { isFetching, participants, totalPages, pagination, setPagination, setSearchValue, setCategory: updateParticipantCategory, } = useFetchParticipants({
        initialPage: 0,
        initialPageSize: DEFAULT_PAGE_SIZE,
    });
    const [selectedCategory, setSelectedCategory] = useState(EParticipantCategory.ACTIVE);
    const categoryFilters = useMemo(() => [
        {
            id: EParticipantCategory.ACTIVE,
            label: translate('Active'),
        },
        {
            id: EParticipantCategory.DEACTIVATED,
            label: translate('Deactivated'),
        },
    ], [translate]);
    const handleSearch = useDebouncedCallback((searchValue) => {
        setSearchValue(searchValue);
    }, 500);
    const handleCategoryFilterChange = (item) => {
        setSelectedCategory(item.id);
        updateParticipantCategory(item.id);
        setPagination({ pageIndex: 0, pageSize: DEFAULT_PAGE_SIZE });
    };
    const activeCategoryIndex = useMemo(() => {
        const activeIdx = categoryFilters.findIndex((filter) => filter.id === selectedCategory);
        return activeIdx;
    }, [selectedCategory]);
    return (_jsx(Table, { columns: participantsColumns, data: participants || [], onSearch: handleSearch, searchFunction: () => {
            //  Always return true to disable client side search. Handle server side search with onSearch
            return true;
        }, isLoading: isFetching, labelNoResults: translate('info.participants_table.empty'), paginationNavigationScreenReaderLabel: translate('info.participants_table.navigation'), useInternalSearch: true, labelSearchField: translate('generic.search'), hasPagination: true, manualPagination: true, initialPageSize: DEFAULT_PAGE_SIZE, pageCount: totalPages, manualPaginationState: pagination, onPaginationChange: setPagination, customHeaderContent: _jsx("div", { className: 'w-full flex items-center justify-end', children: _jsx(SegmentedControl, { activeItemIndex: activeCategoryIndex, items: categoryFilters, onItemClick: handleCategoryFilterChange }) }) }));
};
